import { ContentBlockHeroProduct } from '@dfh-corp-sites/ui'
import BlockContent from '@sanity/block-content-to-react'
import { GatsbyImage } from 'gatsby-plugin-image'
import React, { useMemo } from 'react'

import {
  SanityContentBlockHeroProduct as SanityContentBlockHeroProductProps,
  SanityCta,
} from '../../../graphql/gatsby'
import { setAnalyticsEvent } from '../../../lib/analytics/state'
import { useSanityRoleBasedContent } from '../../../lib/sanity'
import { getGatsbyImageDataForAsset } from '../../../utils/sanity/image'
import SanityLink, { NormalizedSanityLinkTagged } from '../../global/SanityLink'

const setAnalyticsEventOnClick = (
  cta: SanityCta,
  link: NormalizedSanityLinkTagged,
  productTitle: string | null | undefined,
) => {
  setAnalyticsEvent({
    event: 'select_content',
    content_type: 'content block',
    item_id: `sanitycontentblock-heroproduct`,
    title: productTitle || '',
    label_text: cta.title || '',
    link_destination: link._tag === 'Normalized' ? link.href ?? undefined : link._tag,
    module_name: 'SanityContentBlock',
    module_variant: 'SanityContentBlockHeroProduct',
  })
}

const SanityContentBlockHeroProduct = ({
  heading,
  productImage,
  productImageAltText,
  productCategory,
  productTitle,
  productDescription,
  primaryCta,
  secondaryCta,
  backgroundText,
  roleBasedContent,
}: SanityContentBlockHeroProductProps) => {
  const { shouldDisplay } = useSanityRoleBasedContent({ roleBasedContent })

  const imgElt = useMemo((): JSX.Element | undefined => {
    const imageData = getGatsbyImageDataForAsset(productImage, {
      width: 690,
      placeholder: 'blurred',
    })

    return imageData ? (
      <div className="relative">
        <GatsbyImage image={imageData} loading="eager" alt={productImageAltText || ''} />
      </div>
    ) : undefined
  }, [productImage, productImageAltText])

  const headingContent = heading ? <BlockContent blocks={heading} /> : null

  const productCtaChildren =
    primaryCta?.link && primaryCta.link.target && primaryCta.link.target.length > 0 ? (
      <SanityLink
        to={primaryCta.link}
        onClick={(_e, normalized) => setAnalyticsEventOnClick(primaryCta, normalized, productTitle)}
      >
        {primaryCta.title}
      </SanityLink>
    ) : null
  const shopAllCtaChildren =
    secondaryCta?.link && secondaryCta.link.target && secondaryCta.link.target.length > 0 ? (
      <SanityLink
        to={secondaryCta.link}
        onClick={(_e, normalized) =>
          setAnalyticsEventOnClick(secondaryCta, normalized, productTitle)
        }
      >
        {secondaryCta.title}
      </SanityLink>
    ) : null

  if (!shouldDisplay) return null
  return (
    <ContentBlockHeroProduct
      heading={headingContent}
      productImage={imgElt}
      productCategory={productCategory || ''}
      productTitle={productTitle || ''}
      productDescription={productDescription || ''}
      primaryCta={productCtaChildren}
      secondaryCta={shopAllCtaChildren}
      backgroundText={backgroundText || ''}
    />
  )
}
export default SanityContentBlockHeroProduct
